import React from 'react';
import { formatCount, getSegmentColor, type CallStatusSummaryCard } from '../callStatusSummary.utils';
import { ProgressBreakdown, type ProgressLegendItem } from './ProgressBreakdown';

export type StatusDeepDivePanelProps = {
    card: CallStatusSummaryCard;
    statusColor: string;
    styles?: React.CSSProperties;
};

export const StatusDeepDivePanel: React.FC<StatusDeepDivePanelProps> = ({ card, statusColor, styles }) => {
    const items: ProgressLegendItem[] = card.subStatuses.map((sub, index) => ({
        id: sub.id,
        label: sub.label,
        count: sub.count,
        percent: sub.percent,
        color: getSegmentColor(statusColor, index),
    }));

    return (
        <ProgressBreakdown
            title={`${card.label} breakdown`}
            subtitle={`Split of ${formatCount(card.count)} ${card.label.toLowerCase()} calls`}
            items={items}
            testId={`call-status-deep-dive-${card.id}`}
            panelId={`call-status-panel-${card.id}`}
            labelledBy={`call-status-tab-${card.id}`}
            role='tabpanel'
            styles={styles}
        />
    );
};
